import type { UnderlyingProductWithHelpers } from '@shared/products-core';
import { createMenuItemRegistry } from '@shared/products-core';
import { createRegistry } from '@luna/utils';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const menuItemRegistry = () => createMenuItemRegistry<UnderlyingProductWithHelpers<any>>({});
type menuItemRegistryType = ReturnType<typeof menuItemRegistry>;

interface ProductType {
    defaultIcon: string;
    getIconName: ((account: any) => string) | null;
    /** the prefix in the url path for products (e.g: "currentAccount"
     * is the urlPart in "currentAccount/:id/transactions) */
    urlPart: string;
    /** the default page to show for this product type (e.g: transactions) */
    defaultView: string;
    externalData: boolean;
    /** Flag which gets set to true once, when the productType is registered */
    isRegistered: boolean;
    menuItemRegistry: menuItemRegistryType;
}

export function getBaseType(): ProductType {
    return {
        defaultIcon: '',
        getIconName: null,
        menuItemRegistry: createRegistry(),
        urlPart: 'account',
        defaultView: '',
        externalData: false,
        isRegistered: false,
    };
}

const baseType = getBaseType();

const productTypeRegistry = createRegistry<ProductType>({});

export const productsTypeService = {
    get: (typeId: string): ProductType => {
        return productTypeRegistry.get(typeId) || baseType;
    },
    register: (typeId: string, typeInformation: ProductType): void => {
        productTypeRegistry.set(typeId, {
            ...typeInformation,
            isRegistered: true,
        });
    },
    unregister: (typeId: string): void => {
        productTypeRegistry.unset(typeId);
    },
};

export const registerProduct: typeof productsTypeService.register = (typeId, typeInformation) => {
    productsTypeService.register(typeId, typeInformation);
};

export const getProductMenuItems = (typeId: string) =>
    productsTypeService.get(typeId).menuItemRegistry.getAllValues();
